import Controller from '@ember/controller';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';
import { tracked } from 'tracked-built-ins';

export default class CommunicationsSettingsController extends Controller {
  @service declare abilities: AbilitiesService;
  @service declare state: StateService;

  @tracked messageCategoriesSettingsExpanded: boolean = false;

  // EMNO-475: once the home/VIPs or travelers split is on, this page renders the migrated
  // emno-fe settings iframe instead of the native "Message categories" panel. Gated via the
  // global-communication ability so the split check lives in one place.
  get useMigratedSettings(): boolean {
    return this.abilities.can('view-migrated-settings global-communications');
  }

  get iframeUrl(): string {
    return urlBuilder.emno.embeddedGlobalSettingsUrl(this.state.currentCompany.id);
  }
}
